import { Injectable } from '@angular/core';
import { EoHttpClient, IHttpParams } from 'ngx-eo-web-components';
import { CoreService } from '../../modules/core/core.service';
import { ApiCallHandler } from '../../modules/core/models/apiCallHandler';
import { Hospital } from '../../modules/core/models/hospital.model';
import { HospitalPub } from '../../modules/core/models/hospital-pub.model';
import { finalize } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HospitalService {
  public hospitalListCallHandler = new ApiCallHandler<HospitalPub[]>();
  public hospitalFetchCallHandler = new ApiCallHandler<HospitalPub>();

  constructor(private http: EoHttpClient, private coreService: CoreService) {}

  init() {
    this.hospitalListCallHandler.init([]);
    this.hospitalFetchCallHandler.init();
  }

  private isLoading = false;

  // Fetch all hospitals and populate the handler if data is not already loaded
  ensureHospitalDataLoaded() {
    if (this.isLoading) {
      return this.hospitalListCallHandler.data$;
    }

    if (!this.hospitalListCallHandler.data$.getValue()?.length) {
      this.isLoading = true;
      return this.getAllHospitals().pipe(
        finalize(() => {
          this.isLoading = false;
        })
      );
    }
    return this.hospitalListCallHandler.data$;
  }

  getAllHospitals() {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/Hospitals/list`,
      this.hospitalListCallHandler
    );

    return this.http.get<HospitalPub[]>(param);
  }

  getHospitalById(hospitalId:string) {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/Hospitals/fetch/${hospitalId}`,
      this.hospitalFetchCallHandler
    );

    return this.http.get<HospitalPub>(param);
  }
}
